/**
 * Expands the compact {@link formatCardDueLabel} token into the card tile's
 * due line:
 *
 * - a mastered card → `"Mastered"`,
 * - a scheduled token (`"5d"` / `"3h"` / `"5m"`) → `"Due in 5d"`,
 * - `"Tomorrow"` → `"Due tomorrow"`,
 * - `"Due"` (the card is due now) → `"Due now"`,
 * - `undefined` (no schedule yet) → `"No due date"`.
 */
export function formatCardDueLine(
  dueLabel: string | undefined,
  { isMastered = false }: { isMastered?: boolean } = {},
): string {
  if (isMastered) {
    return "Mastered";
  }
  if (dueLabel === undefined) {
    return "No due date";
  }
  if (dueLabel === "Due") {
    return "Due now";
  }
  if (dueLabel === "Tomorrow") {
    return "Due tomorrow";
  }
  return `Due in ${dueLabel}`;
}
